/*
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-07-14 10:23:41
 * @LastEditors: Betway huangbo@mrcdevlab.com
 * @LastEditTime: 2025-03-12 16:28:53
 * @FilePath: \mrc-base-server-view\src\mixin\index.js
 */
import vuelidate from './vuelidate';
import national from './national'
import btnPermission from './btnPermission'
export default {
  install (v) {
    v.mixin(vuelidate)
    v.mixin(national)
    v.mixin(btnPermission)
  }
}